import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import LandingPage from './pages/LandingPage';
import InitData from './utilz/initializeFirebaseData';
import { useAuth } from './components/auth/AuthContext';
import ProfilePage from './pages/ProfilePage';
import { AuthProvider } from './components/auth/AuthContext';
import Navbar from './components/navbar';
import { Layout, Spin, message } from 'antd';

const LoadingSpinner = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <Spin size="large" />
  </div>
);

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  if (loading) return <LoadingSpinner />;
  return currentUser ? children : <Navigate to="/login" replace />;
};

const AuthRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  if (loading) return <LoadingSpinner />;
  return !currentUser ? children : <Navigate to="/" replace />;
};

function App() {
  const [messageApi, contextHolder] = message.useMessage();

  return (
    <BrowserRouter>
      <AuthProvider>
        {contextHolder}
        <Layout>
          <Routes>
            <Route path="/login" element={<AuthRoute><Login messageApi={messageApi} /></AuthRoute>} />
            <Route path="/register" element={<AuthRoute><Register messageApi={messageApi} /></AuthRoute>} />
            <Route path="/" element={
              <>
                <Navbar />
                <Layout.Content>
                  <div className="App">
                    <InitData />
                    <ProtectedRoute>
                      <LandingPage />
                    </ProtectedRoute>
                  </div>
                </Layout.Content>
              </>
            } />
            <Route path="/profile/:id" element={
              <>
                <Navbar />
                <Layout.Content>
                  <div className="App">
                    <ProtectedRoute>
                      <ProfilePage />
                    </ProtectedRoute>
                  </div>
                </Layout.Content>
              </>
            } />
          </Routes>
        </Layout>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
